import { FC } from 'react';
import { Redirect, Route, RouteComponentProps, withRouter } from 'react-router-dom';

import { routes } from '~src/routingConfig';

import ErrorPage from './ErrorPage';

interface OwnProps {
  isAuthenticated?: boolean;
}

type Props = OwnProps & RouteComponentProps<object>;

const PageNotFound: FC<Props> = ({ isAuthenticated = true, history }) => {
  const goToOverview = () => history.push(routes.reports.sessionUser);
  const renderRoute = () =>
    isAuthenticated ? (
      <ErrorPage
        buttonAction={goToOverview}
        messageKey="x.not_found_page.title"
        buttonKey="x.not_found_page.button"
      />
    ) : (
      <Redirect to={routes.login} />
    );

  return <Route render={renderRoute} />;
};

const PageNotFountWithRouter = withRouter(PageNotFound);

export default PageNotFountWithRouter;
